"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from '@phosphor-icons/react/dist/ssr';
import { motion } from "framer-motion";

export default function NotFound() {
  return (
    <main className="bg-[#f8f9ff] min-h-screen font-sans antialiased text-[#0b1c30] selection:bg-[#b80035] selection:text-white flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="max-w-md w-full bg-white rounded-xl border border-gray-100 shadow-[0_4px_20px_rgba(15,23,42,0.04)] overflow-hidden text-center"
      >
        <div className="relative w-full h-56">
          <Image
            fill
            src="/assets/not_found_scene.jpg"
            alt="An empty plate on the pass after service"
            className="object-cover"
            priority
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-transparent to-transparent" />
          <span className="absolute bottom-4 left-1/2 -translate-x-1/2 font-sora text-5xl font-extrabold text-white tracking-tight">
            404
          </span>
        </div>

        <div className="p-8">
          <h1 className="text-2xl font-bold tracking-tight text-[#0b1c30] mb-2">
            Off the menu
          </h1>
          <p className="text-sm text-[#565e74] mb-8 leading-relaxed">
            We searched the whole kitchen, but this page isn&apos;t on the menu tonight.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => window.history.back()}
              className="px-6 py-3 rounded-lg border border-gray-200 text-[#565e74] font-semibold text-sm hover:bg-gray-50 transition-all"
            >
              Go back
            </button>
            <Link
              href="/"
              className="px-6 py-3 rounded-lg bg-[#b80035] text-white font-semibold text-sm hover:bg-[#920028] active:scale-[0.99] transition-all shadow-md shadow-[#b80035]/10 flex items-center justify-center gap-2"
            >
              Go home <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </motion.div>
    </main>
  );
}
